import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { SUGGESTION_CHIP } from '../MessageList';

/**
 * A question Hana asks right above the message box (the paste prompt, the split offer): one line, its chips, and a
 * ✕ that leaves it unanswered.
 */
export function OfferBox({ label, question, dismissLabel, onDismiss, children }: {
  label: string; question: ReactNode; dismissLabel: string; onDismiss: () => void; children: ReactNode;
}) {
  return (
    <div role="group" aria-label={label}
      className="flex items-start gap-2 rounded-lg border border-[hsl(var(--h-border))] bg-[hsl(var(--h-muted)/0.5)] py-1.5 pl-2.5 pr-1">
      <div className="min-w-0 flex-1">
        <p className="py-1 text-sm text-[hsl(var(--h-card-foreground))]">{question}</p>
        <div className="mt-1 flex flex-wrap gap-1.5">{children}</div>
      </div>
      <button type="button" aria-label={dismissLabel} title={dismissLabel} onClick={onDismiss}
        className="flex size-11 shrink-0 items-center justify-center rounded-md text-[hsl(var(--h-muted-foreground))] transition-colors hover:bg-[hsl(var(--h-muted))] hover:text-[hsl(var(--h-card-foreground))] lg:size-7">
        <X className="size-4" aria-hidden="true" />
      </button>
    </div>
  );
}

export function OfferChip({ onClick, disabled, children }: { onClick: () => void; disabled?: boolean; children: ReactNode }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled}
      className={`${SUGGESTION_CHIP} inline-flex items-center font-medium disabled:cursor-default disabled:opacity-50`}>
      {children}
    </button>
  );
}
